// Wire values, unlike UserRole: the mockups label a tier by its pill colour, so
// the display text comes from subscriptionLabel instead.
export enum SubscriptionTier {
  DEMO = 'DEMO',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
}

// Add-ons are coloured and grouped per category, not per add-on, so a new add-on
// inherits its category's.
export enum AddOnCategory {
  STORAGE = 'storage',
  USERS = 'users',
  MAPS = 'maps',
  MODULES = 'modules',
}

// Wire values of `addonType` on GET /admin/addons and on a client's assigned
// add-ons; the catalogue can ship a type we haven't mapped, so reads fall back.
export enum AddOnType {
  STORAGE = 'STORAGE',
  MAPS = 'MAPS',
  INFRASTRUCTURE = 'INFRASTRUCTURE',
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
}

// A length is sent as whole years; these are the two lengths that aren't one.
export enum SpecialTerm {
  DEMO = 'demo',
  CURRENT = 'current',
}

export enum BillingStatus {
  PAID = 'PAID',
  PENDING = 'PENDING',
}

// FILTERS panel: expiration status checkboxes.
export enum ExpirationFilterOption {
  ACTIVE = 'active',
  EXPIRED = 'expired',
}

// FILTERS panel: storage metric checkboxes.
export enum StorageFilterOption {
  USED = 'used',
  AVAILABLE = 'available',
  TOTAL = 'total',
}
